import { query_my_rel_org_list } from 'liyu-pc-base/api/org-model';

export default () => {
  const search_config: any = {
    model: {},
    watch: [],
  };

  return {
    getData: query_my_rel_org_list,
    searchConfig: search_config,
  };
};
